<template>
	<div class="title-page">
		<h1 class="title">Détails du logement</h1>
	</div>
	<div class="card-top">
		<div class="card blue">
			<div class="split">
				<div class="half">
					<div class="info">
						<div class="info-row">
							<label class="info-label b">Nom:</label>
							<span class="info-value">{{ currentProperty.name }}</span>
						</div>
						<div class="info-row">
							<label class="info-label b">Type:</label>
							<span class="info-value">{{ currentProperty.type }}</span>
						</div>
						<div class="info-row">
							<label class="info-label b">Adresse:</label>
							<span class="info-value">{{ currentProperty.address }}</span>
						</div>
					</div>
					<div class="partage">
						<router-link to="/mes-partages/ajouter" class="button fill orange">Partager</router-link>
					</div>
				</div>
				<div class="dpe">
					<div :class="['dpe-letter', getDPEColor(currentProperty.Etiquette_DPE)]">
						{{ getDPELetter(currentProperty.Etiquette_DPE, currentProperty.Etiquette_GES) }}
					</div>
					<div v-if="isDPEProvided(currentProperty)" class="dpe-text">
						<span><span class="b">{{ currentProperty.Conso_usages }}</span> kWh/m²/an</span>
						<span><span class="b">{{ currentProperty.Emission_GES }}</span> kg CO2/m²/an</span>
					</div>
					<span v-else>DPE Non fourni</span>
				</div>
				<router-link to="/mes-partages/ajouter" class="small-partage">
					<i data-v-26ff2c60="" class="bi bi-share-fill"></i>
				</router-link>
			</div>
		</div>
		<div class="card white pdg-25">
			<div id="map" class="map-container" ref="mapContainer"></div>
		</div>
	</div>
	<div class="card white large no-pdg">
		<div class="file-ctn">
			<h2>Documents liés au logement</h2>
			<FileSizeProgress ref="fileSizeProgress" :propID="currentProperty.ID" />
		</div>
		<div v-if="Object.keys(filteredGroupedTypes).length == 0" style="text-align: center; padding: 50px">
			<h2>Aucun fichiers trouvé</h2>
			<img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png"
				alt="Aucun équipement trouvé" />
		</div>
		<div v-else v-for="(types, categoryName) in filteredGroupedTypes" :key="categoryName" class="category">
			<h3 @click="toggleCategoryVisibility(categoryName)">
				{{ categoryName }}
				<i class="bi"
					:class="{ 'bi-caret-right-fill': !visibleCategories[categoryName], 'bi-caret-down-fill': visibleCategories[categoryName] }"></i>
			</h3>
			<div v-if="visibleCategories[categoryName]" class="types">
				<div class="card white pdg-25 flx" v-for="typee in types" :key="typee.ID">
					<div>
						<h4>{{ typee.name }}</h4>
						<input type="file" :ref="'fileInput_' + typee.ID"
							@change="(event) => handleFileChange(event, typee.name, typee.categorieID)"
							style="display: none" />
						<div v-for="file in typee.files" :key="file.ID" class="file-entry">
							<i class="bi bi-file-earmark-pdf-fill"></i>
							<p class="file-name">{{ file.name }}</p>
							<i class="file-icon bi bi-download" @click="downloadFile(file.ID)"></i>
							<i class="file-icon bi bi-eye-fill" @click="viewFile(file.ID)"></i>
							<i class="file-icon bi bi-trash-fill" @click="openPopup(file.ID)"></i>
						</div>
					</div>
					<button @click="simulateFileInputClick($event, $refs['fileInput_' + typee.ID])"
						class="button outline normal">Ajouter un fichier</button>
				</div>
				<div class="card transparent" @click="openUploadFile(types[0].categorieID)">
					<i class="bi bi-plus-circle-dotted" style="font-size: 50px; color: #000"></i>
				</div>
			</div>
		</div>
	</div>
	<ConfirmationPopup :isVisible="showPopup" title="Confirmer la suppression"
		message="Êtes-vous sûr de vouloir supprimer ce fichier ?" @confirm="deleteFile" @cancel="closePopup">
	</ConfirmationPopup>
	<LogementSelectPopup :isVisible="showUploadFile" title="Ajouter un fichier" :categorieID="categorieToAdd"
		:groupedTypes="inverseFilteredGroupedTypes" :propID="currentProperty.ID" @confirm="uploadFile"
		@cancel1="closeUploadFile">
	</LogementSelectPopup>
</template>

<script>
import LogementSelectPopup from "@/components/LogementSelectPopup.vue";
import ConfirmationPopup from "@/components/ConfirmationPopup";
import FileSizeProgress from "@/components/FileSizeProgress.vue";

/* global google */
export default {
	name: "MesLogements",
	props: ["currentProperty", "user", "searchQuery"],
	components: {
		ConfirmationPopup,
		LogementSelectPopup,
		FileSizeProgress,
	},
	data() {
		return {
			types: [],
			visibleCategories: {},
			files: [],
			totalFileSize: {
				number: 0,
				unit: "o",
			},
			fileToDelete: "",
			showPopup: false,
			categorieToAdd: "",
			showUploadFile: false,
		};
	},
	mounted() {
		if (this.currentProperty && Object.keys(this.currentProperty).length > 0) {
			this.fetchTypes();
			this.initMap();
		}
		this.$watch("currentProperty", () => {
			if (this.currentProperty && Object.keys(this.currentProperty).length > 0) {
				this.fetchTypes();
				this.initMap();
			}
		});
	},
	methods: {
		filterTypesBySearchQuery(types) {
			if (!this.searchQuery) {
				return types;
			}
			const lowerCaseQuery = this.searchQuery.toLowerCase();
			return types.filter((type) => {
				return type.name.toLowerCase().includes(lowerCaseQuery) ||
					(type.files && type.files.some(file => file.name.toLowerCase().includes(lowerCaseQuery)));
			});
		},
		getCategoryNameById(categoryID) {
			const category = this.types.find((type) => type.categorieID === categoryID)?.FilesCategory.name;
			return category || null;
		},
		simulateFileInputClick(event, fileInput) {
			event.preventDefault();
			event.stopPropagation();
			fileInput[0].click();
		},
		async handleFileChange(event, type, categorie) {
			const file = event.target.files[0];
			const selectedFileType = file.type;
			if (selectedFileType === "image/jpeg" || selectedFileType === "image/png" || selectedFileType === "application/pdf") {
				this.selectedFile = event.target.files[0];
			} else {
				alert("Seuls les fichiers JPEG, PNG et PDF sont autorisés.");
				event.target.value = null;
				return;
			}
			const formData = new FormData();
			formData.append("categorie", categorie);
			formData.append("propID", this.currentProperty.ID);
			formData.append("type", type);
			formData.append("file", file);

			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "fichiers/add", { method: "POST", credentials: "include", body: formData, });
				const data = await response.json();

				if (data.message === "maxsize") alert("La taille totale des fichiers dépasse la limite.");
				if (!response.ok) return alert("Une erreur est survenue lors de la requête.");

				this.fetchTypes();
				event.target.value = null;
			} catch (error) {
				console.error("Erreur lors de la soumission du formulaire:", error);
			}
		},
		async fetchFiles() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "fichiers/p/" + this.currentProperty.ID, { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.error) {
					window.location.href = "/login";
				} else {
					this.files = data;
					this.totalFileSize = this.calculateTotalFileSize();
				}
			} catch (error) {
				console.log("Une erreur est survenue lors de la requête.");
			}
		},
		async fetchTypes() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "fichiers/types", { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.error) {
					window.location.href = "/login";
				} else {
					this.types = data;
					this.fetchFiles();
					this.initializeVisibleCategories();
					this.resetFileSizeProgress();
				}
			} catch (error) {
				console.log("Une erreur est survenue lors de la requête.");
			}
		},
		getDPELetter(dpe, ges) {
			const letters = [];
			if (dpe) letters.push(dpe);
			if (ges) letters.push(ges);

			if (letters.length === 0) return "-";

			return letters.sort()[letters.length - 1];
		},
		getDPEColor(letter) {
			switch (letter) {
				case "A": return "color-A";
				case "B": return "color-B";
				case "C": return "color-C";
				case "D": return "color-D";
				case "E": return "color-E";
				case "F": return "color-F";
				case "G": return "color-G";
				default: return "color-Z";
			}
		},
		isDPEProvided(property) {
			return (property.Etiquette_DPE && property.Etiquette_DPE.trim() !== "") ||
				(property.Etiquette_GES && property.Etiquette_GES.trim() !== "") ||
				property.Conso_usages > 0 ||
				property.Emission_GES > 0;
		},
		initializeVisibleCategories() {
			let isFirstCategory = true;
			this.types.forEach((type) => {
				const categoryName = type.FilesCategory.name;
				if (!this.visibleCategories[categoryName]) {
					if (isFirstCategory) {
						isFirstCategory = false;
						this.visibleCategories[categoryName] = true;
					} else {
						this.visibleCategories[categoryName] = false;
					}
				}
			});
		},
		toggleCategoryVisibility(categoryName) {
			this.visibleCategories[categoryName] = !this.visibleCategories[categoryName];
		},
		async initMap() {
			try {
				const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(this.currentProperty.address)}&key=AIzaSyDPtjQ8RlwmsbbNrYRSJbp7MnQHqhsS254`);
				const data = await response.json();

				if (data.results.length === 0) {
					console.error("Adresse invalide.");
					return;
				}

				const location = data.results[0].geometry.location;
				const map = new google.maps.Map(document.getElementById("map"), {
					zoom: 15,
					center: location,
					mapId: "LOGEMENT_ID",
				});

				new google.maps.marker.AdvancedMarkerElement({
					position: location,
					map: map,
					title: "Agence",
				});
			} catch (error) {
				console.error("Une erreur s'est produite :", error);
			}
		},
		openPopup(fileId) {
			this.fileToDelete = fileId;
			this.showPopup = true;
		},
		viewFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "read/" + fileId;
			window.open(url, "_blank");
		},
		downloadFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "download/" + fileId;
			window.open(url, "_blank");
		},
		closePopup() {
			this.showPopup = false;
		},
		uploadFile() {
			this.fetchTypes();
			this.showUploadFile = false;
		},
		openUploadFile(categorieID) {
			this.categorieToAdd = categorieID;
			this.showUploadFile = true;
		},
		closeUploadFile() {
			this.showUploadFile = false;
		},
		async deleteFile() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "fichiers/delete/" + this.fileToDelete, { method: "DELETE", credentials: "include", });
				if (!response.ok) return alert("Erreur : " + this.fileToDelete);

				this.closePopup();
				this.fileToDelete = "";
				this.fetchTypes();
			} catch (error) {
				console.log("Une erreur est survenue lors de la requête.");
			}
		},
		resetFileSizeProgress() {
			this.$refs.fileSizeProgress.reset();
		},
	},
	computed: {
		progressBarWidth() {
			const maxSizeInMo = 100;
			const totalSizeInMo = this.convertToMo(this.totalFileSize.number, this.totalFileSize.unit);
			return (totalSizeInMo / maxSizeInMo) * 100;
		},
		groupedTypes() {
			const categories = {};
			const seenFiles = new Set();

			this.types.forEach((type) => {
				const categoryName = type.FilesCategory.name;
				if (!categories[categoryName]) {
					categories[categoryName] = [];
				}
				type.files = [];
				categories[categoryName].push(type);
			});

			this.files.forEach((file) => {
				if (seenFiles.has(file.ID)) return;

				const categoryName = this.getCategoryNameById(file.categoryID) || "Autre";
				if (!categories[categoryName]) categories[categoryName] = [];

				const existingType = categories[categoryName].find((type) => type.name === file.type);

				if (existingType) {
					existingType.files.push(file);
				} else {
					const artificialType = {
						ID: `artificial-${file.ID}`,
						name: file.type,
						categorieID: file.categoryID,
						visible: true,
						FilesCategory: {
							name: categoryName,
						},
						files: [file],
					};
					categories[categoryName].push(artificialType);
				}

				seenFiles.add(file.ID);
			});

			return categories;
		},
		filteredGroupedTypes() {
			const filteredCategories = {};
			for (const [categoryName, types] of Object.entries(this.groupedTypes)) {
				const visibleTypes = this.filterTypesBySearchQuery(types).filter((type) => type.visible || (type.files && type.files.length > 0));
				if (visibleTypes.length > 0) filteredCategories[categoryName] = visibleTypes;
			}
			return filteredCategories;
		},
		inverseFilteredGroupedTypes() {
			const filteredCategories = {};
			for (const [categoryName, types] of Object.entries(this.groupedTypes)) {
				const invisibleTypes = types.filter((type) => !type.visible && (!type.files || type.files.length === 0));
				if (invisibleTypes.length > 0) filteredCategories[categoryName] = invisibleTypes;
			}
			return filteredCategories;
		},
	},
};
</script>

<style scoped>
.card.flx {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.card.flx button {
	margin-top: 15px;
}

.split {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.split .half {
	display: flex;
	gap: 20px;
}

.info {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 15px;
}

.info-row {
	display: flex;
	justify-content: space-between;
	gap: 10px;
}

.info-label {
	flex-basis: 20%;
}

.info-value {
	flex-basis: 70%;
}

.dpe {
	display: flex;
	align-items: center;
	gap: 20px;
}

.dpe .dpe-text {
	display: flex;
	flex-wrap: wrap;
	column-gap: 10px;
	row-gap: 0px;
}

.partage {
	flex: 0 0 auto;
	display: flex;
	align-items: flex-start;
}

.small-partage {
	display: none;
	color: #ff8017;
	font-size: 22px;
	position: absolute;
	right: 30px;
	top: 20px;
}

.card-map {
	padding: 25px !important;
}

@media (max-width: 950px) {
	.partage {
		display: none
	}

	.small-partage {
		display: block;
	}
}
</style>
